/* LUMLY · Configura e ordina */
(function () {
  'use strict';
  var root = document.querySelector('[data-lwb]');
  if (!root) return;
  var cfgEl = root.querySelector('[data-lwb-cfg]');
  if (!cfgEl) return;
  var C, IMG = {};
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  try { IMG = JSON.parse(root.querySelector('[data-lwb-img]').textContent); } catch (e) {}

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var EUR = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, useGrouping: 'always' });
  var NUM = new Intl.NumberFormat('it-IT', { useGrouping: 'always' });
  var M2 = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var eur = function (n) { return EUR.format(Math.ceil(n / 10) * 10); };
  var m = function (mm) { return M2.format(mm / 1000) + ' m'; };
  var KIT = { nx: 10, ny: 8, cw: 500, ch: 500 };
  var MAXW = 30000, MAXH = 12000;
  var PRESETS = { def: [[2, 1], [3, 2], [4, 2.25], [5, 3], [6, 3.5]], vitreo: [[1, 2], [1.5, 2.5], [2, 2.5], [3, 3]] };

  var S = { line: null, model: null, size: null, nx: 0, ny: 0, sens: null, slide: 0 };

  function lineOf(k) { for (var i = 0; i < C.lines.length; i++) if (C.lines[i].k === k) return C.lines[i]; return null; }
  function modelOf(id) { for (var i = 0; i < C.models.length; i++) if (C.models[i].id === id) return C.models[i]; return null; }
  function modelsOf(k) { return C.models.filter(function (x) { return x.l === k; }); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function pitch(p) { return String(p).replace('.', ','); }

  /* ---------- calcolo ---------- */
  function geo() {
    var md = modelOf(S.model); if (!md) return null;
    var g = md.kit ? { nx: KIT.nx, ny: KIT.ny, cw: KIT.cw, ch: KIT.ch } : md.unit ? { nx: 1, ny: 1, cw: md.cw, ch: md.ch } : { nx: S.nx, ny: S.ny, cw: md.cw, ch: md.ch };
    if (!g.nx || !g.ny) return null;
    g.w = g.nx * g.cw; g.h = g.ny * g.ch;
    g.area = md.kit ? md.kitm2 : (g.w / 1000) * (g.h / 1000);
    g.pw = Math.round(g.w / md.p); g.ph = Math.round(g.h / md.p); g.px = g.pw * g.ph;
    g.n = g.nx * g.ny; g.film = !!md.film; g.kit = !!md.kit; g.unit = !!md.unit;
    return g;
  }
  function player(px) { var P = C.acc.players; for (var i = 0; i < P.length; i++) if (px <= P[i][0]) return P[i]; return null; }
  function price(sens) {
    var md = modelOf(S.model), g = geo(); if (!md || !g) return null;
    var a = C.acc, t = a.fix, pl = null;
    if (md.nop || (!md.kit && !md.m2)) return { over: true, g: g };
    if (g.kit) { t += md.kit; }
    else {
      pl = player(g.px); if (!pl) return { over: true, g: g };
      t += g.area * md.m2 + pl[1];
      if (g.film) t += a.film; else t += g.n * a.card;
    }
    if (sens) t += a.sens;
    return { total: t, pl: pl, g: g };
  }
  function snap(mm, cell, max) { var n = Math.max(1, Math.round(mm / cell)); while (n * cell > max && n > 1) n--; return n; }

  /* ---------- rendering opzioni ---------- */
  function opt(attrs, main, sub, right) {
    var b = el('button', 'lwb-opt');
    b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
    for (var k in attrs) b.setAttribute(k, attrs[k]);
    b.innerHTML = '<span class="lwb-opt__m"><b>' + main + '</b>' + (sub ? '<small>' + sub + '</small>' : '') + '</span>' + (right ? '<span class="lwb-opt__p">' + right + '</span>' : '');
    return b;
  }
  function check(container, attr, val) {
    $$(container + ' [' + attr + ']').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute(attr) === String(val) ? 'true' : 'false'); });
  }

  function renderLines() {
    var box = $('[data-lwb-lines]'); box.innerHTML = '';
    C.lines.forEach(function (l) { box.appendChild(opt({ 'data-line': l.k }, esc(l.n), esc(l.d), l.from ? 'da ' + eur(l.from) + '/m²' : 'Su preventivo')); });
    var min = Math.min.apply(null, C.lines.filter(function (l) { return l.from; }).map(function (l) { return l.from; }));
    $('[data-lwb-from]').textContent = 'LED wall a partire da ' + eur(min) + '/m², IVA esclusa.';
  }
  function renderModels() {
    var box = $('[data-lwb-models]'); box.innerHTML = '';
    var ms = modelsOf(S.line), groups = [['in', 'Per interni'], ['out', 'Per esterni']];
    var both = ms.some(function (x) { return x.amb === 'in'; }) && ms.some(function (x) { return x.amb === 'out'; });
    groups.forEach(function (gr) {
      var list = ms.filter(function (x) { return x.amb === gr[0]; }); if (!list.length) return;
      if (both) box.appendChild(el('p', 'lwb-sub', gr[1]));
      list.forEach(function (x) {
        var sub = ['Passo ' + pitch(x.p) + ' mm', x.nits, x.ip, x.ambl !== 'Interno' && x.ambl !== 'Esterno' ? x.ambl : ''].filter(Boolean).join(' · ');
        var right = x.nop || (!x.kit && !x.m2) ? 'Su preventivo' : x.kit ? eur(x.kit + C.acc.fix) : eur(x.m2) + '/m²';
        box.appendChild(opt({ 'data-model': x.id }, esc(x.n), esc(sub), right));
      });
    });
  }
  function presetList(md) {
    var P = PRESETS[md.l] || PRESETS.def, seen = {}, out = [];
    P.forEach(function (t) {
      var nx = snap(t[0] * 1000, md.cw, MAXW), ny = snap(t[1] * 1000, md.ch, MAXH), k = nx + 'x' + ny;
      if (!seen[k]) { seen[k] = 1; out.push([nx, ny]); }
    });
    return out;
  }
  function renderSizes() {
    var md = modelOf(S.model), box = $('[data-lwb-sizes]'); box.innerHTML = '';
    var cust = $('[data-lwb-custom]');
    if (md.unit) {
      $('[data-lwb-sizep]').textContent = 'Formato fisso: indica nelle note quanti pezzi ti servono.';
      box.appendChild(opt({ 'data-size': 'kit' }, M2.format(md.cw / 1000) + ' × ' + M2.format(md.ch / 1000) + ' m', '1 pezzo', ''));
      S.size = 'kit'; cust.hidden = true; return;
    }
    if (md.kit) {
      $('[data-lwb-sizep]').textContent = 'Il kit comprende 20 m² di cabinet, componibili nel formato che preferisci.';
      var b = opt({ 'data-size': 'kit' }, 'Kit 20 m²', '80 cabinet 500 × 500 mm · es. 5 × 4 m', '');
      box.appendChild(b); S.size = 'kit'; cust.hidden = true; return;
    }
    $('[data-lwb-sizep]').textContent = md.film ? 'La pellicola si taglia sulla misura del tuo vetro.' : 'Le misure si adattano ai cabinet reali del modello: ' + md.cw + ' × ' + md.ch + ' mm.';
    presetList(md).forEach(function (p, i) {
      var w = p[0] * md.cw, h = p[1] * md.ch, area = (w / 1000) * (h / 1000);
      box.appendChild(opt({ 'data-size': String(i), 'data-nx': p[0], 'data-ny': p[1] }, M2.format(w / 1000) + ' × ' + M2.format(h / 1000) + ' m', M2.format(area) + ' m²', ''));
    });
    box.appendChild(opt({ 'data-size': 'custom' }, 'Su misura', 'Imposta larghezza e altezza', ''));
    sizePrices();
  }
  function sizePrices() {
    $$('[data-lwb-sizes] [data-nx]').forEach(function (b) {
      var keep = [S.nx, S.ny]; S.nx = +b.getAttribute('data-nx'); S.ny = +b.getAttribute('data-ny');
      var p = price(false); S.nx = keep[0]; S.ny = keep[1];
      var sm = b.querySelector('small'), base = sm.textContent.split(' · ')[0];
      sm.textContent = base + ' · ' + (p && !p.over ? 'da ' + eur(p.total) : 'su preventivo');
    });
  }

  /* ---------- galleria ---------- */
  var slides = [];
  function buildGallery() {
    var k = S.line || (C.lines[1] && C.lines[1].k) || C.lines[0].k;
    var imgs = IMG[k] && IMG[k].length ? IMG[k] : [];
    var track = $('[data-lwb-track]'), cur = track.getAttribute('data-k');
    if (cur !== k) {
      track.setAttribute('data-k', k); track.innerHTML = '';
      imgs.forEach(function (src, i) { var im = el('img'); im.src = src; im.alt = (lineOf(k) ? lineOf(k).n : 'LED wall') + ' LUMLY, immagine ' + (i + 1); im.loading = i ? 'lazy' : 'eager'; im.decoding = 'async'; track.appendChild(im); });
    }
    slides = imgs.map(function (_, i) { return { t: 'img', i: i }; });
    if (S.model && geo()) slides.push({ t: 'scale' });
    if (S.slide >= slides.length) S.slide = 0;
    var dots = $('[data-lwb-dots]'); dots.innerHTML = '';
    slides.forEach(function (sl, i) {
      var b = el('button'); b.type = 'button';
      if (sl.t === 'scale') { b.textContent = 'In scala'; b.setAttribute('aria-label', 'Vista in scala'); }
      else { b.className = 'is-dot'; b.setAttribute('aria-label', 'Immagine ' + (i + 1)); }
      b.addEventListener('click', function () { show(i); });
      dots.appendChild(b);
    });
    $('[data-lwb-gal] .lwb-gal__nav').style.display = slides.length > 1 ? '' : 'none';
    show(S.slide);
  }
  function show(i) {
    if (!slides.length) return;
    S.slide = (i + slides.length) % slides.length;
    var sl = slides[S.slide], sc = $('[data-lwb-scale]');
    $$('[data-lwb-track] img').forEach(function (im, j) { im.classList.toggle('is-on', sl.t === 'img' && sl.i === j); });
    sc.hidden = sl.t !== 'scale';
    if (sl.t === 'scale') drawScale();
    $$('[data-lwb-dots] button').forEach(function (b, j) { b.setAttribute('aria-current', j === S.slide ? 'true' : 'false'); });
    $('[data-lwb-cap]').textContent = sl.t === 'scale' ? 'Proporzioni reali rispetto a una persona alta 1,75 m.' : 'Immagini illustrative.';
  }
  function drawScale() {
    var g = geo(); if (!g) return;
    var W = g.w / 1000, H = g.h / 1000, lift = (g.kit || g.unit) ? 0 : (H < 2.6 ? 0.8 : 0), top = H + lift;
    var x0 = -1.1, x1 = W + 0.25, y0 = -(Math.max(top, 1.75) + 0.5), y1 = 0.55;
    var vw = x1 - x0, vh = y1 - y0, fs = Math.max(vw, vh * 1.3) * 0.028;
    var s = '<svg viewBox="' + [x0, y0, vw, vh].join(' ') + '" preserveAspectRatio="xMidYMid meet" role="img" aria-label="LED wall di ' + M2.format(W) + ' per ' + M2.format(H) + ' metri accanto a una persona">';
    s += '<defs><linearGradient id="lwbG" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f5a623" stop-opacity=".34"/><stop offset=".55" stop-color="#f5a623" stop-opacity=".12"/><stop offset="1" stop-color="#f5a623" stop-opacity=".05"/></linearGradient></defs>';
    s += '<line x1="' + x0 + '" y1="0" x2="' + x1 + '" y2="0" stroke="rgba(255,255,255,.22)" stroke-width="' + fs * 0.08 + '"/>';
    s += '<rect x="0" y="' + (-top) + '" width="' + W + '" height="' + H + '" fill="url(#lwbG)" stroke="rgba(255,255,255,.7)" stroke-width="' + fs * 0.09 + '"/>';
    if (!g.film && g.nx <= 60 && g.ny <= 40) {
      var cw = g.cw / 1000, ch = g.ch / 1000, l = '';
      for (var i = 1; i < g.nx; i++) l += 'M' + (i * cw) + ' ' + (-top) + 'v' + H;
      for (var j = 1; j < g.ny; j++) l += 'M0 ' + (-top + j * ch) + 'h' + W;
      s += '<path d="' + l + '" stroke="rgba(255,255,255,.16)" stroke-width="' + fs * 0.05 + '" fill="none"/>';
    }
    var px = -0.6;
    s += '<g fill="rgba(255,255,255,.34)"><circle cx="' + px + '" cy="-1.63" r=".115"/><rect x="' + (px - 0.19) + '" y="-1.49" width=".38" height=".66" rx=".12"/><rect x="' + (px - 0.16) + '" y="-0.92" width=".14" height=".92" rx=".06"/><rect x="' + (px + 0.02) + '" y="-0.92" width=".14" height=".92" rx=".06"/></g>';
    var tx = 'font-family="Inter,-apple-system,sans-serif" font-size="' + fs + '" fill="rgba(245,245,247,.72)"';
    s += '<text x="' + (W / 2) + '" y="' + (fs * 1.6) + '" text-anchor="middle" ' + tx + '>' + M2.format(W) + ' m</text>';
    s += '<text x="' + (W + fs * 1.1) + '" y="' + (-top + H / 2) + '" ' + tx + ' dominant-baseline="middle" transform="rotate(90 ' + (W + fs * 1.1) + ' ' + (-top + H / 2) + ')" text-anchor="middle">' + M2.format(H) + ' m</text>';
    s += '<text x="' + px + '" y="' + (fs * 1.6) + '" text-anchor="middle" ' + tx + '>1,75 m</text>';
    s += '</svg>';
    $('[data-lwb-scale]').innerHTML = s;
  }

  /* ---------- stato e riepilogo ---------- */
  function open(step, on) { var s = $('[data-step="' + step + '"]'); if (s) s.classList.toggle('is-open', !!on); }
  function update() {
    check('[data-lwb-lines]', 'data-line', S.line);
    check('[data-lwb-models]', 'data-model', S.model);
    check('[data-lwb-sizes]', 'data-size', S.size);
    check('[data-lwb-sens]', 'data-sens', S.sens);
    var md = modelOf(S.model), g = geo();
    open('model', !!S.line); open('size', !!md); open('ctrl', !!(md && g)); open('sum', !!(md && g && S.sens != null));
    $('[data-lwb-custom]').hidden = !(S.size === 'custom' && md && !md.kit && !md.unit);
    $('[data-lwb-dist]').textContent = md ? 'Con il passo ' + pitch(md.p) + ' mm l’immagine è nitida da circa ' + NUM.format(Math.max(1, Math.round(md.p))) + ' m di distanza in su.' : '';
    var p0 = g ? price(false) : null, p1 = g ? price(S.sens === 1) : null;
    $('[data-lwb-sensp]').textContent = '+ ' + eur(C.acc.sens);
    if (g) {
      $('[data-lwb-wv]').textContent = m(g.w); $('[data-lwb-hv]').textContent = m(g.h);
      var rd = [['Dimensioni', g.kit ? '20 m²' : m(g.w).replace(' m', '') + ' × ' + m(g.h)], ['Superficie', M2.format(g.area) + ' m²'], ['Risoluzione', NUM.format(g.pw) + ' × ' + NUM.format(g.ph) + ' px']];
      $('[data-lwb-read]').innerHTML = rd.map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd></div>'; }).join('');
      var pl = player(g.px);
      $('[data-lwb-player]').textContent = g.unit ? 'Player integrato nel totem: carichi i contenuti da chiavetta o da remoto.' : g.kit ? 'Il kit comprende già player, schede riceventi e cablaggi NovaStar.' :
        pl ? 'Player NovaStar ' + pl[2] + (g.film ? '' : ' e ' + g.n + ' schede riceventi') + ', dimensionati su ' + NUM.format(g.pw) + ' × ' + NUM.format(g.ph) + ' px.' :
        'Per questa risoluzione progettiamo un sistema di controllo dedicato, definito nel preventivo.';
    } else { $('[data-lwb-read]').innerHTML = ''; }
    // riepilogo
    var tot = p1 && !p1.over ? eur(p1.total) : (g ? 'Su preventivo' : '—');
    if (md && g) {
      $('[data-lwb-sumn]').textContent = 'LUMLY ' + md.n;
      var rows = [['Linea', lineOf(md.l).n], ['Passo pixel', pitch(md.p) + ' mm'], ['Dimensioni', g.kit ? 'Kit 20 m²' : m(g.w).replace(' m', '') + ' × ' + m(g.h)], ['Risoluzione', NUM.format(g.pw) + ' × ' + NUM.format(g.ph) + ' px'], [g.film ? 'Superficie' : 'Cabinet', g.film ? M2.format(g.area) + ' m²' : g.n + ' × ' + g.cw + '×' + g.ch + ' mm'], ['Luminosità', S.sens === 1 ? 'Sensore automatico' : 'Manuale']];
      $('[data-lwb-sum]').innerHTML = rows.map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('');
      $('[data-lwb-total]').textContent = tot;
      var pl2 = player(g.px), box = [];
      if (g.unit) box = ['Totem LED ' + m(g.cw).replace(' m', '') + ' × ' + m(g.ch) + ' con player integrato', 'Alimentazione e cavi', 'Schede tecniche e manuali'];
      else if (g.kit) box = ['80 cabinet 500 × 500 mm ad aggancio rapido', 'Sistema di controllo NovaStar completo', 'Cavi di segnale e di alimentazione', 'Flight case per trasporto e stoccaggio', 'Schede tecniche e manuali'];
      else if (g.film) box = ['Pellicola LED trasparente ' + m(g.w).replace(' m', '') + ' × ' + m(g.h), 'Alimentazione e cablaggi', pl2 ? 'Player NovaStar ' + pl2[2] : 'Sistema di controllo dedicato', 'Istruzioni di applicazione e schede tecniche'];
      else box = [g.n + ' cabinet ' + g.cw + ' × ' + g.ch + ' mm, moduli LED montati', 'Alimentatori e ' + g.n + ' schede riceventi integrati', pl2 ? 'Player NovaStar ' + pl2[2] : 'Sistema di controllo dedicato', 'Cavi di segnale e di alimentazione', 'Schema di montaggio e mappatura dei cabinet', 'Schede tecniche e manuali'];
      if (S.sens === 1) box.splice(box.length - 1, 0, 'Sensore di luminosità NovaStar');
      $('[data-lwb-box]').innerHTML = box.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
      var body = rows.map(function (r) { return r[0] + ': ' + r[1]; }).join('\n') + '\nPrezzo indicativo: ' + tot + ' IVA esclusa';
      $('[data-lwb-mail]').href = 'mailto:info@lumly.it?subject=' + encodeURIComponent('Preventivo personalizzato LUMLY ' + md.n) + '&body=' + encodeURIComponent('Buongiorno,\nvorrei un preventivo personalizzato per questa configurazione:\n\n' + body + '\n\n');
    }
    var ready = !!(md && g && S.sens != null);
    $('[data-lwb-order]').disabled = !ready;
    // barra
    var bar = $('[data-lwb-bar]');
    if (md) {
      $('[data-lwb-barn]').textContent = 'LUMLY ' + md.n;
      $('[data-lwb-bars]').textContent = g ? (g.kit ? 'Kit 20 m²' : m(g.w).replace(' m', '') + ' × ' + m(g.h)) : 'Scegli le dimensioni';
      $('[data-lwb-barp]').textContent = g ? (S.sens === 1 ? tot : (p0 && !p0.over ? eur(p0.total) : 'Su preventivo')) : (md.nop || (!md.kit && !md.m2) ? 'Su preventivo' : md.kit ? eur(md.kit + C.acc.fix) : 'da ' + eur(md.m2) + '/m²');
      $('[data-lwb-barbtn]').textContent = ready ? 'Invia l’ordine' : 'Continua';
    }
    barState();
    buildGallery();
    saveHash();
  }

  /* ---------- barra inferiore ---------- */
  var ctaVisible = false, inSection = false;
  function barState() {
    var bar = $('[data-lwb-bar]'), on = !!S.model && inSection && !ctaVisible;
    bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    $('[data-lwb-barbtn]').tabIndex = on ? 0 : -1;
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { ctaVisible = e[0].isIntersecting; barState(); }).observe($('[data-lwb-order]'));
    new IntersectionObserver(function (e) { inSection = e[0].isIntersecting; barState(); }, { rootMargin: '0px 0px -40% 0px' }).observe($('.lwb-grid'));
  } else { inSection = true; }

  function nextStep() {
    var order = ['line', 'model', 'size', 'ctrl', 'sum'];
    var need = !S.line ? 'line' : !S.model ? 'model' : !geo() ? 'size' : S.sens == null ? 'ctrl' : 'sum';
    var t = $('[data-step="' + need + '"]');
    if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--lw-hdr')) || 92) - 24, behavior: 'smooth' });
    return order.indexOf(need);
  }

  /* ---------- eventi ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || !root.contains(b)) return;
    if (b.hasAttribute('data-line')) {
      var k = b.getAttribute('data-line'); if (S.line !== k) { S.line = k; S.model = null; S.size = null; S.nx = S.ny = 0; S.slide = 0; renderModels(); }
      update(); return;
    }
    if (b.hasAttribute('data-model')) {
      S.model = b.getAttribute('data-model'); var md = modelOf(S.model);
      if (md.kit || md.unit) { S.size = 'kit'; }
      else { var pl = presetList(md), i = Math.min(2, pl.length - 1); S.size = String(i); S.nx = pl[i][0]; S.ny = pl[i][1]; }
      renderSizes(); update(); return;
    }
    if (b.hasAttribute('data-size')) {
      var v = b.getAttribute('data-size'); S.size = v;
      if (b.hasAttribute('data-nx')) { S.nx = +b.getAttribute('data-nx'); S.ny = +b.getAttribute('data-ny'); }
      update(); return;
    }
    if (b.hasAttribute('data-inc') || b.hasAttribute('data-dec')) {
      var md2 = modelOf(S.model); if (!md2 || md2.kit) return;
      var ax = b.getAttribute('data-inc') || b.getAttribute('data-dec'), d = b.hasAttribute('data-inc') ? 1 : -1;
      var minN = md2.film ? 5 : 1;
      if (ax === 'w') S.nx = Math.max(minN, Math.min(Math.floor(MAXW / md2.cw), S.nx + d));
      else S.ny = Math.max(minN, Math.min(Math.floor(MAXH / md2.ch), S.ny + d));
      S.size = 'custom'; update(); return;
    }
    if (b.hasAttribute('data-sens')) { S.sens = +b.getAttribute('data-sens'); update(); return; }
    if (b.hasAttribute('data-lwb-prev')) { show(S.slide - 1); return; }
    if (b.hasAttribute('data-lwb-next')) { show(S.slide + 1); return; }
    if (b.hasAttribute('data-lwb-barbtn')) { if (nextStep() === 4 && !$('[data-lwb-order]').disabled) order(); return; }
    if (b.hasAttribute('data-lwb-order')) { order(); return; }
  });
  // frecce nei gruppi di scelta
  root.addEventListener('keydown', function (e) {
    var b = e.target.closest && e.target.closest('[role="radio"]'); if (!b) return;
    if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(e.key) < 0) return;
    var g = Array.prototype.slice.call(b.closest('[role="radiogroup"]').querySelectorAll('[role="radio"]'));
    var i = g.indexOf(b) + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1);
    var n = g[(i + g.length) % g.length]; n.focus(); n.click(); e.preventDefault();
  });

  /* ---------- ordine ---------- */
  function order() {
    var btn = $('[data-lwb-order]'), err = $('[data-lwb-err]');
    var md = modelOf(S.model), g = geo(), p = price(S.sens === 1); if (!md || !g || S.sens == null) return;
    err.hidden = true; btn.classList.add('is-busy'); btn.disabled = true; btn.textContent = 'Invio in corso…';
    var props = {
      'Linea': lineOf(md.l).n, 'Modello': 'LUMLY ' + md.n, 'Passo pixel': pitch(md.p) + ' mm',
      'Dimensioni': g.kit ? 'Kit 20 m² (80 cabinet 500 × 500 mm)' : m(g.w).replace(' m', '') + ' × ' + m(g.h),
      'Superficie': M2.format(g.area) + ' m²', 'Risoluzione': NUM.format(g.pw) + ' × ' + NUM.format(g.ph) + ' px'
    };
    if (!g.film && !g.kit) props['Cabinet'] = g.n + ' × ' + g.cw + '×' + g.ch + ' mm';
    var pl = player(g.px); props['Controllo'] = g.unit ? 'Player integrato' : g.kit ? 'NovaStar incluso nel kit' : pl ? 'NovaStar ' + pl[2] : 'Da definire nel preventivo';
    props['Sensore di luminosità'] = S.sens === 1 ? 'Sì' : 'No';
    props['Prezzo indicativo (IVA esclusa)'] = p && !p.over ? eur(p.total) : 'Da definire nel preventivo';
    var co = $('[data-lwb-co]').value.trim(), nt = $('[data-lwb-note]').value.trim();
    if (co) props['Azienda o ente'] = co;
    if (nt) props['Note'] = nt;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: C.variant, quantity: 1, properties: props }] }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () { window.location.href = base + 'checkout'; })
      .catch(function () {
        btn.classList.remove('is-busy'); btn.disabled = false; btn.textContent = 'Invia l’ordine';
        err.textContent = 'Non siamo riusciti a inviare l’ordine. Riprova oppure scrivici a info@lumly.it.'; err.hidden = false;
      });
  }

  /* ---------- link condivisibile ---------- */
  function saveHash() {
    if (!S.line) return;
    var q = ['l=' + S.line]; if (S.model) q.push('m=' + S.model); if (S.model && !modelOf(S.model).kit && !modelOf(S.model).unit && S.nx) q.push('x=' + S.nx, 'y=' + S.ny); if (S.sens != null) q.push('s=' + S.sens);
    try { history.replaceState(null, '', '#' + q.join('&')); } catch (e) {}
  }
  function loadHash() {
    var h = {}; (location.hash || '').replace(/^#/, '').split('&').forEach(function (kv) { var p = kv.split('='); if (p[1]) h[p[0]] = decodeURIComponent(p[1]); });
    if (h.l && lineOf(h.l)) { S.line = h.l; renderModels(); }
    var md = h.m && modelOf(h.m);
    if (md && md.l === S.line) {
      S.model = md.id; renderSizes();
      if (md.kit || md.unit) S.size = 'kit';
      else if (h.x && h.y) {
        S.nx = Math.max(1, Math.min(Math.floor(MAXW / md.cw), parseInt(h.x, 10) || 1)); S.ny = Math.max(1, Math.min(Math.floor(MAXH / md.ch), parseInt(h.y, 10) || 1));
        S.size = 'custom'; presetList(md).forEach(function (p, i) { if (p[0] === S.nx && p[1] === S.ny) S.size = String(i); });
      } else { var pr = presetList(md), pi = Math.min(2, pr.length - 1); S.size = String(pi); S.nx = pr[pi][0]; S.ny = pr[pi][1]; }
      if (h.s === '0' || h.s === '1') S.sens = +h.s;
    }
  }

  renderLines();
  loadHash();
  update();
})();
